<template>
    <main>
        <v-card class="pa-5 mb-10">
            <v-container>
                <div class="ma-5">
                    <h1 class="text-center">{{ schedule[0].title }}</h1>
                </div>
                <div class="mb-5">
                    <v-icon small>fa fa-map-marker-alt</v-icon>
                    {{ schedule[0].location }}
                </div>
                <div class="mb-5">
                    <v-icon small>fa fa-quote-right</v-icon>
                    {{ schedule[0].description }}
                </div>
                <!-- <v-simple-table>
                <template v-slot:default> -->
                <div class="table-outer">
                    <table class="mx-auto sh-table">
                        <thead>
                            <tr>
                                <th class="text-left" style="max-width:250px">
                                    <!-- <h3 class="mb-4">Deltagarens namn</h3> -->
                                </th>
                                <th
                                    v-for="date in dates"
                                    :key="date.id"
                                    class="text-center"
                                    style="width:150px"
                                >
                                    <!-- <div style="background-color:orange;color:#fff;font-size:18px;border-radius:5px" class="pa-2">
                            {{ toDDMMMYY(date.schedule_date) }}
                        </div> -->
                                    <div
                                        style="background-color:orange;color:#fff;font-size:18px;border-radius:5px;"
                                        class="pa-2"
                                    >
                                        <div class="month">
                                            {{ toMonth(date.schedule_date) }}
                                        </div>
                                        <div class="day">
                                            {{ toDay(date.schedule_date) }}
                                        </div>
                                    </div>
                                    <div
                                        style="font-size:14px"
                                        class="pa-2 grey--text text--darken-1 font-weight-regular"
                                    >
                                        <div>
                                            {{ toDaytext(date.schedule_date) }}
                                        </div>
                                        {{
                                            toMMHH(date.time_from) === "00:00"
                                                ? "-"
                                                : toMMHH(date.time_from)
                                        }}
                                        {{
                                            toMMHH(date.time_to) === "00:00"
                                                ? ""
                                                : " - " + toMMHH(date.time_to)
                                        }}
                                    </div>
                                </th>
                            </tr>
                            <tr
                                v-show="
                                    schedule[0].hidden_schedule === 'no' ||
                                        schedule[0].user_id ===
                                            store.state.user.id
                                "
                            >
                                <th class="text-left">
                                    {{ participants_count }} Deltagare
                                </th>
                                <th
                                    v-for="date in dates"
                                    :key="date.id"
                                    class="text-center"
                                >
                                    {{ date.participant_count }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                style="border: 3px solid rgb(255 165 0);"
                                v-if="
                                    schedule[0].one_answer == 'no' &&
                                        !datePassed() &&
                                        schedule[0].status == 'yes'
                                "
                            >
                                <th style="vertical-align: bottom;">
                                    <div class="text-left mb-3">
                                        Ange vilka tider du kan
                                    </div>
                                    <v-text-field
                                        v-model="name"
                                        placeholder="Ditt namn"
                                        required
                                        outlined
                                        dense
                                    />
                                </th>
                                <!-- <td>
                            <v-text-field
                                v-model="comment"
                                placeholder="Kommentar"
                                required
                            />
                        </td> -->
                                <td
                                    class="ys-box"
                                    v-for="(date, i) in selectedDates"
                                    :key="i"
                                >
                                    <v-checkbox
                                        v-model="date.status"
                                        v-if="
                                            schedule[0].if_needed_option ===
                                                'no'
                                        "
                                    />
                                    <!-- <input type="radio"
                                            class="radio"
                                            name="i"
                                            v-model="date.status"
                                            @change="onRadioChange(i)"
                                        /> -->
                                    <v-radio-group
                                        v-model="date.status"
                                        v-if="
                                            schedule[0].if_needed_option ===
                                                'yes'
                                        "
                                    >
                                        <v-radio
                                            class="radio"
                                            v-for="(checkbox, i) in checkBoxes"
                                            :key="i"
                                            :label="checkbox.label"
                                            :value="checkbox.value"
                                        />
                                    </v-radio-group>
                                    <div class="comment-label-sm">Kommentarer</div>
                                    <v-textarea
                                    class="comment-txt"
                                        outlined
                                        dense
                                        @click="dialogg = true"
                                        label="Kommentarer"
                                        v-model="dateComments[i].comment"
                                        rows="1"
                                    />
                                    <!-- <v-dialog v-model="dialogg" persistent max-width="290">
      <v-card>
        <v-card-title class="headline"></v-card-title>
        <v-card-text>
            <v-textarea
            outlined
            dense
                label="Kommentarer"
                v-model="dateComments[i].comment"
            />
            </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialogg = false">Disagree</v-btn>
          <v-btn color="green darken-1" text @click="dialogg = false">Agree</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
                                </td>
                                <!-- <td
                            v-show="det && schedule[0].ask_for_contact == 'yes'"
                            v-for="(det, i) in contact"
                            :key="det"
                        >
                            <v-text-field :label="det" v-model="ci[i]" />
                        </td> -->
                                <!-- <td>
                            <v-btn
                                style="background-color:#ffa500;margin-bottom:20px"
                                @click="submit"
                                >Sända
                                <v-icon style="margin-left:3px;font-size:15px">
                                    fas fa-check</v-icon
                                ></v-btn
                            >
                        </td> -->
                            </tr>

                            <tr
                                v-if="
                                    !alreadyReplied() &&
                                        schedule[0].one_answer == 'yes' &&
                                        !datePassed() &&
                                        schedule[0].status == 'yes'
                                "
                            >
                                <td>
                                    <v-text-field
                                        v-model="name"
                                        placeholder="Ditt namn"
                                        required
                                    />
                                </td>
                                <!-- <td>
                            <v-text-field
                                v-model="comment"
                                placeholder="Kommentar"
                                required
                            />
                        </td> -->
                                <td v-for="(date, i) in selectedDates" :key="i">
                                    <v-checkbox
                                        v-model="date.status"
                                        v-if="
                                            schedule[0].if_needed_option ===
                                                'no'
                                        "
                                    />
                                    <v-radio-group
                                        v-model="date.status"
                                        v-if="
                                            schedule[0].if_needed_option ===
                                                'yes'
                                        "
                                    >
                                        <v-row>
                                            <v-radio
                                                class="radio"
                                                v-for="(checkbox,
                                                i) in checkBoxes"
                                                :key="i"
                                                :label="checkbox.label"
                                                :value="checkbox.value"
                                            />
                                        </v-row>
                                    </v-radio-group>
                                    <v-row
                                        >
                                        <div style="font-size:10px">Kommentarer</div>
                                        <v-textarea
                                             class="comment-txt"
                                            label="Kommentarer"
                                            v-model="dateComments[i].comment"
                                            rows="1"
                                        />
                                    </v-row>
                                </td>
                                <!-- <td
                            v-show="det && schedule[0].ask_for_contact == 'yes'"
                            v-for="(det, i) in contact"
                            :key="det"
                        >
                            <v-text-field :label="det" v-model="ci[i]" />
                        </td> -->
                                <td></td>
                            </tr>
                            <tr
                                class="name-row"
                                v-show="
                                    schedule[0].hidden_schedule === 'no' ||
                                        schedule[0].user_id ===
                                            store.state.user.id
                                "
                                v-for="participant in participation_table"
                                :key="participant.id"
                            >
                                <td style="display:flex;justify-content: space-between;">
                                    {{ participant.name }}
                                    <!-- <div v-if="participant.user_id === store.state.user.id" > -->
                                        <v-icon v-if="editbtn === false" @click="edit(participant)"
                                            >fas fa-edit</v-icon>
                                            <!-- </div> -->
                                    </td>
                                <td
                                    v-for="date in participant.dates"
                                    :key="date.id"
                                ><div v-if="participant.edit === true">
                                    <v-checkbox
                                        v-model="date.status"
                                        :value="date.status"
                                        :false-value="'0'"
                                        :true-value="'1'"
                                        v-if="
                                            schedule[0].if_needed_option ===
                                                'no'
                                        "
                                    />
                                    <v-radio-group
                                        v-model="date.status"
                                        v-if="
                                            schedule[0].if_needed_option ===
                                                'yes'
                                        "
                                    >
                                        <v-row>
                                            <v-radio
                                                class="radio"
                                                v-for="(checkbox,
                                                i) in checkBoxess"
                                                :key="i"
                                                :label="checkbox.label"
                                                :value="checkbox.value"
                                            />
                                        </v-row>
                                    </v-radio-group>
                                    </div>
                                    <div v-else>
                                    <div
                                        class="green lighten-4 pa-2 text-center"
                                        v-if="date.status == 1"
                                        style="position:relative"
                                    >
                                        <v-tooltip
                                            bottom
                                            v-if="date.comment !== ''"
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <span v-bind="attrs" v-on="on"
                                                    ><i style="position: absolute;left: 18%;top: 10px;"
                                                        class="far fa-comment-dots"
                                                    ></i
                                                ></span>
                                            </template>
                                            <span>{{ date.comment }}</span>
                                        </v-tooltip>
                                            <v-icon style="color:green;"
                                            >fas fa-check</v-icon
                                        >
                                    </div>
                                    <div
                                        class="red lighten-4 pa-2 text-center"
                                        v-else-if="date.status == 0"
                                        style="position:relative;"
                                    >
                                                                            <v-tooltip
                                            bottom
                                            v-if="date.comment !== ''"
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <span v-bind="attrs" v-on="on"
                                                    ><i style="position: absolute;left: 18%;top: 10px;"
                                                        class="far fa-comment-dots"
                                                    ></i
                                                ></span>
                                            </template>
                                            <span>{{ date.comment }}</span>
                                        </v-tooltip>
                                        <v-icon style="color:red"
                                            >fas fa-times</v-icon
                                        >
                                    </div>
                                    <div
                                        class="yellow lighten-4 pa-2 text-center"
                                        v-else style="position:relative;"
                                    >
                                    <v-tooltip
                                            bottom
                                            v-if="date.comment !== ''"
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <span v-bind="attrs" v-on="on"
                                                    ><i style="position: absolute;left: 18%;top: 10px;"
                                                        class="far fa-comment-dots"
                                                    ></i
                                                ></span>
                                            </template>
                                            <span>{{ date.comment }}</span>
                                        </v-tooltip>
                                        <v-icon
                                            title="Om det behövs"
                                            style="margin-left:10px;color:orange"
                                            >fas fa-minus</v-icon
                                        >
                                        <!-- Om det behövs -->
                                    </div>
                                    <div>
                                        
                                    </div>
                                    </div>
                                </td>
                            </tr>
                            <tr
                                v-if="
                                    schedule[0].one_answer == 'yes' &&
                                        alreadyReplied()
                                "
                            >
                                <td style="text-align:center" colspan="5">
                                    <!-- {{alreadyReplied()}} -->
                                    Du har redan svarat för det här schemat
                                </td>
                            </tr>
                            <tr
                                v-if="
                                    datePassed() || schedule[0].status == 'no'
                                "
                            >
                                <td style="text-align:center" colspan="5">
                                    Svarsdatum för schemat har passerat.
                                </td>
                            </tr>
                        </tbody>
                        <!-- </template>
            </v-simple-table> -->
                    </table>
                </div>
                <div
                    v-show="schedule[0].ask_for_contact == 'yes'"
                    v-if="!datePassed() && schedule[0].status == 'yes'"
                >
                    <v-text-field label="E-mail" v-model="email" required />
                    <v-text-field
                        label="Mobilnummer"
                        v-model="phone"
                        required
                    />
                </div>
                <div v-if="!datePassed() && schedule[0].status == 'yes'">
                    <div
                        v-show="det && schedule[0].ask_for_contact == 'yes'"
                        v-for="(det, i) in contact"
                        :key="det"
                    >
                        <v-text-field :label="det" v-model="ci[i]" />
                    </div>
                </div>
                <v-alert v-model="alert" type="error" dismissible>
                    {{ alertmsg }}
                </v-alert>
                <div
                    class="text-right"
                    v-if="!datePassed() && schedule[0].status == 'yes'"
                >
                <v-btn v-if="updatebtn.edit== true" style="background-color:#ffa500;" @click="updatebtn.edit = false;editbtn= false"
                        >Annullera</v-btn
                    >
                    <v-btn
                     v-if="editbtn== true"
                      style="background-color:#ffa500;"
                       @click="update"
                       data-id=""
                        >Uppdatering
                        <v-icon style="font-size:15px">
                            fas fa-check</v-icon
                        ></v-btn
                    >
                    <v-btn v-else style="background-color:#ffa500;" @click="submit"
                        >Skicka
                        <v-icon style="font-size:15px">
                            fas fa-check</v-icon
                        ></v-btn
                    >
                </div>
            </v-container>
        </v-card>
        <v-card
            class="pa-5 mb-10"
            v-if="!datePassed() && schedule[0].status == 'yes'"
        >
            <v-container class="pa-5 text-center">
                <v-row>
                    <v-col cols="12">
                        <h4>Alla med länken kan rösta - inget konto behövs</h4>
                    </v-col>
                    <v-col cols="6" class="mx-auto">
                        <v-text-field
                            :value="copyLink()"
                            dense
                            outlined
                            readonly
                        ></v-text-field>
                        <v-btn
                            v-clipboard="copyLink"
                            text
                            style="background-color:#ffa500;"
                        >
                            Kopiera länk
                            <v-icon style="margin-left:3px;font-size:15px"
                                >fas fa-copy</v-icon
                            >
                        </v-btn>
                    </v-col>
                    <v-col cols="12">
                        <div class="social">
                            <a
                                :href="
                                    'https://www.facebook.com/sharer/sharer.php?u=' +
                                        shareLink
                                "
                                target="_blank"
                                class="mr-2 text-decoration-none"
                            >
                                <v-icon x-large color="#3b5998"
                                    >fab fa-facebook</v-icon
                                ></a
                            >
                            <a
                                :href="
                                    'https://api.whatsapp.com/send?text=' +
                                        shareLink
                                "
                                target="_blank"
                                class="mr-2"
                            >
                                <v-icon x-large color="#25d366"
                                    >fab fa-whatsapp</v-icon
                                ></a
                            >
                            <a
                                :href="
                                    'http://www.twitter.com/share?url=' +
                                        shareLink
                                "
                                target="_blank"
                                class="mr-2"
                            >
                                <v-icon x-large color="#1da1f2"
                                    >fab fa-twitter</v-icon
                                ></a
                            >
                            <a
                                :href="
                                    'https://telegram.me/share/url?url=' +
                                        shareLink
                                "
                                target="_blank"
                                class="mr-2"
                            >
                                <v-icon x-large color="blue darken-2"
                                    >fab fa-telegram</v-icon
                                ></a
                            >
                            <a
                                :href="'mailto:?body=' + shareLink"
                                target="_blank"
                                class="mr-2"
                            >
                                <v-icon x-large color="#ff4500"
                                    >fas fa-envelope</v-icon
                                ></a
                            >
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
        <v-card class="pa-5 mb-10">
            <v-container>
                <h2 class="mb-5">Allmäna kommentarer</h2>
                <v-card
                    v-for="com in comments"
                    v-bind:key="com.id"
                    class="mb-2"
                >
                    <v-list-item three-line>
                        <v-list-item-avatar size="60" color="primary"
                            ><v-icon large dark
                                >fas fa-user-circle</v-icon
                            ></v-list-item-avatar
                        >
                        <v-list-item-content>
                            <div>
                                <h5>{{ com.name }}</h5>
                            </div>
                            <v-list-item-subtitle>{{
                                com.comment
                            }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-card>
                <v-textarea
                    v-model="comment"
                    required
                    outlined
                    v-if="!datePassed() && schedule[0].status == 'yes'"
                />
                <v-alert v-model="alertc" type="error" dismissible>
                    {{ alertmsgc }}
                </v-alert>
                <v-btn
                    v-if="!datePassed() && schedule[0].status == 'yes'"
                    style="background-color:#ffa500;"
                    @click="submitComment"
                    >Publicera kommentar
                    <v-icon style="font-size:15px"> fas fa-check</v-icon></v-btn
                >
            </v-container>
        </v-card>
        <v-card class="pa-5 mb-10">
            <v-container v-show="schedule[0].user_id === store.state.user.id">
                <h2>Inställningar</h2>
                
                        <h3>Redigera schema</h3>
                <v-row>
                    <v-col>
                        <v-btn
                        :to="'/editmeeting/'+ schedule[0].id"
                        
                    >
                        Redigera titel / beskrivning
                        </v-btn>
                    </v-col>
                    <v-col>
                        <v-btn
                        :to="'/updateschedule/'+ schedule[0].id"
                        
                    >
                        Redigera datum / alternativ
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-switch
                            v-model="voting"
                            label="Stäng omröstningen"
                            @click="switchVote"
                        />
                    </v-col>
                </v-row>
                <v-row v-show="(voting = true)">
                    <v-col cols="12" md="6">
                        <v-select
                            :items="admindates"
                            label="Valt datum"
                            outlined
                            item-text="name"
                            item-value="name"
                            v-model="finaldate"
                            dense
                        ></v-select>
                        <v-alert v-model="alertm" type="error" dismissible>
                            {{ alertmsgm }}
                        </v-alert>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-btn
                            style="background-color:#ffa500;"
                            @click="submitMail"
                            >Maila alla mottagare
                            <v-icon style="font-size:15px">
                                fas fa-check</v-icon
                            ></v-btn
                        >
                    </v-col>
                </v-row>
                <v-alert type="success" v-show="alerts" dismissible>
                    e-post skickas.
                </v-alert>
                <v-row>
                    <v-col>
                        <v-dialog v-model="dialog" width="500">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    color="red lighten-1 my-3"
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    Radera Schema
                                </v-btn>
                            </template>

                            <v-card>
                                <v-card-title primary-title> </v-card-title>
                                <v-card-text>
                                    Är du säker på att radera schema?
                                </v-card-text>

                                <v-divider></v-divider>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        color="primary"
                                        text
                                        @click="dialog = false"
                                    >
                                        Annullera
                                    </v-btn>
                                    <v-btn
                                        color="red lighten-1"
                                        text
                                        @click="deleteSchema"
                                    >
                                        Radera Schema
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
        <v-dialog v-model="replydone" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Ditt svar har skickats!</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="redirect">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </main>
</template>

<script>
import axios from "axios";
export default {
    props: ["store"],
    data: function() {
        return {
            link: this.$route.params.link,
            schdule: null,
            schedule: {},
            dates: [],
            month: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "Maj",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Okt",
                "Nov",
                "Dec"
            ],
            weekday: ["Sön", "Mån", "Tis", "Ons", "Tors", "Fre", "Lör"],
            admindates: [],
            participants: [],
            participant_dates: [],
            participation_table: [],
            participants_count: "",
            name: this.store.state.user.fname
                ? this.store.state.user.fname +
                  " " +
                  this.store.state.user.lname
                : "",
            finaldate: "",
            alertmsg: "",
            alertmsgm: "",
            alertmsgc: "",
            updatebtn:[],
            replydone: false,
            alert: false,
            alertc: false,
            alertm: false,
            alerts: false,
            dialog: false,
            dialogg: false,
            editbtn: false,
            selectedDates: [],
            voting: "0",
            comment: "",
            comments: [],
            email: this.store.state.user.email
                ? this.store.state.user.email
                : "",
            phone: "",
            shareLink: "",
            dateComment: "",
            dateComments: [],
            contact: [],
            ci: [],
            checkBoxes: [
                {
                    label: "Ja",
                    value: 1
                },
                {
                    label: "Nej",
                    value: 0
                },
                {
                    label: "Om det behövs",
                    value: 2
                }
            ],
            checkBoxess: [
                {
                    label: "Ja",
                    value: '1'
                },
                {
                    label: "Nej",
                    value: '0'
                },
                {
                    label: "Om det behövs",
                    value: '2'
                }
            ]
        };
    },
    async created() {
        (this.schedule = this.store.state.getSchedule.details),
            (this.dates = this.store.state.getSchedule.dates),
            (this.participants = this.store.state.getSchedule.participants),
            (this.participant_dates = this.store.state.getSchedule.participantDates);
        this.participants_count = this.participants.length;
        if (this.schedule[0].status === "yes") {
            this.voting = false;
        } else {
            this.voting = true;
        }
        this.shareLink = `https://tid.nu/schedule/${this.schedule[0].schedule_link}`;
        for (var i = 0; i < this.participants.length; i++) {
            var participant = {
                id: i,
                user_id: this.participants[i].user_id,
                name: this.participants[i].name,
                comment: this.participants[i].comment,
                dates: [],
                edit: false,
                email: this.participants[i].email,
                phone: this.participants[i].phone,
                ci0: this.participants[i].ci0,
                ci1: this.participants[i].ci1,
                ci2: this.participants[i].ci2,
                ci3: this.participants[i].ci3,
                ci4: this.participants[i].ci4
            };
            for (var j = 0; j < this.participant_dates.length; j++) {
                if (
                    this.participants[i].id ===
                    this.participant_dates[j].participant_id
                )
                    participant.dates.push({
                        date: this.participant_dates[j].id,
                        status: this.participant_dates[j].participant_status,
                        comment: this.participant_dates[j].comment
                    });
            }
            // console.log(participant.dates)
            this.participation_table = [
                ...this.participation_table,
                participant
            ];
            participant = { id: 0, name: "", dates: [] };
        }
        for (i = 0; i < this.dates.length; i++) {
            this.selectedDates[i] = { id: this.dates[i].id, status: false };
            this.admindates.push({
                id: this.dates[i].id,
                name:
                    this.toDDMMMYY(this.dates[i].schedule_date) +
                    " " +
                    this.toMMHH(this.dates[i].time_from) +
                    " - " +
                    this.toMMHH(this.dates[i].time_to)
            });
        }
        this.selectedDates.forEach(date => {
            this.dateComments.push({ id: date.id, comment: "" });
        });
        this.contact = [
            this.schedule[0].contact_info1,
            this.schedule[0].contact_info2,
            this.schedule[0].contact_info3,
            this.schedule[0].contact_info4,
            this.schedule[0].contact_info5
        ];
        this.getComments();
    },
    methods: {
        submit: async function() {
            if (this.name === "") {
                this.alertmsg = "Vänligen fyll i ditt namn";
                this.alert = true;
                return;
            } else if (
                this.email === "" &&
                this.schedule[0].ask_for_contact == "yes"
            ) {
                this.alertmsg = "Ange din e-postadress";
                this.alert = true;
                return;
            } else if (
                this.phone === "" &&
                this.schedule[0].ask_for_contact == "yes"
            ) {
                this.alertmsg = "Ange din mobil";
                this.alert = true;
                return;
            }
            let bodyFormData = new FormData();
            await bodyFormData.append(
                "dates",
                JSON.stringify({ dates: this.selectedDates })
            );
            await bodyFormData.append(
                "schedule_id",
                this.store.state.getSchedule.details[0].id
            );
            if (this.store.state.user.id)
                await bodyFormData.append("user_id", this.store.state.user.id);
            else await bodyFormData.append("user_id", 0);
            await bodyFormData.append("name", this.name);
            await bodyFormData.append("comment", this.comment);
            await bodyFormData.append("email", this.email);
            await bodyFormData.append("phone", this.phone);

            await bodyFormData.append(
                "DateComments",
                JSON.stringify(this.dateComments)
            );

            for (var i = 0; i < 5; i++) {
                if (this.ci[i] != null)
                    bodyFormData.append(`ci${i}`, this.ci[i]);
            }
            var config = {
                method: "post",
                headers: {
                    "Content-Type": "application/form-data;charset=utf-8",
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*"
                },
                data: bodyFormData
            };
            await this.store.dispatch("addParticipant", config);
            this.replydone = true
            // window.location.reload();
        },
        add: function(id) {
            for (var i = 0; i < this.selectedDates.length; i++)
                if (this.selectedDates[i].id === id)
                    this.selectedDates[i].status = 1;
        },
        remove: function(id) {
            for (var i = 0; i < this.selectedDates.length; i++)
                if (this.selectedDates[i].id === id)
                    this.selectedDates[i].status = 0;
        },
        copyLink: function() {
            return this.shareLink;
        },
        alreadyReplied: function() {
            return this.participants.some(
                part => part.user_id == this.store.state.user.id
            );
        },
        datePassed: function() {
            if (this.schedule[0].reply_deadline == "no") return false;

            let date = new Date(Date.now());
            let replyDeadline = new Date(this.schedule[0].reply_deadline_date);
            return date > replyDeadline;
        },
        toDDMMYY(date) {
            let dated = new Date(date);
            return `${dated.getDate()}/${dated.getMonth() +
                1}/${dated.getFullYear()}`;
        },
        toDDMMMYY(date) {
            let dated = new Date(date);
            return `${dated.getDate()} ${
                this.month[dated.getMonth()]
            } ${dated.getFullYear()}`;
        },
        toMMHH(time) {
            return time.substring(0, 5);
        },
        toDay(date) {
            let dated = new Date(date);
            return `${dated.getDate()}`;
        },
        toDaytext(date) {
            let dated = new Date(date);
            return `${this.weekday[dated.getDay()]}`;
        },
        toMonth(date) {
            let dated = new Date(date);
            return `${this.month[dated.getMonth()]}`;
        },
        getComments: async function() {
            var config = {
                method: "get",
                url: `${this.store.state.baseURL}schedule_comments/${this.store.state.getSchedule.details[0].id}`,
                headers: {
                    "Content-Type": "application/form-data;charset=utf-8",
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*"
                }
            };
            let resp = await axios(config);
            this.comments = resp.data.comments;
        },
        submitComment: async function() {
            if (this.comment === "") {
                this.alertmsgc = "Skriv en kommentar";
                this.alertc = true;
                return;
            }
            let bodyFormData = new FormData();
            await bodyFormData.append("comment", this.comment);
            bodyFormData.append("user_id", this.store.state.user.id);
            bodyFormData.append(
                "schedule_id",
                this.store.state.getSchedule.details[0].id
            );
            var config = {
                method: "post",
                url: `${this.store.state.baseURL}addcomment`,
                headers: {
                    "Content-Type": "application/form-data;charset=utf-8",
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*"
                },
                data: bodyFormData
            };
            await axios(config);
            this.getComments();
            this.comment = "";
        },
        switchVote: async function() {
            var config = {
                method: "post",
                url: `${this.store.state.baseURL}switch_voting/${this.schedule[0].id}`,
                headers: {
                    "Content-Type": "application/form-data;charset=utf-8",
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*"
                }
            };
            await axios(config);
            window.location.reload();
        },
        async submitMail() {
            let bodyFormData = new FormData();
            bodyFormData.set("user_id", this.store.state.user.id);
            bodyFormData.set("schedule_id", this.schedule[0].id);
            bodyFormData.set("date", this.finaldate);
            const config = {
                method: "post",
                url: `${this.store.state.baseURL}mailrecepients`,
                headers: {
                    "Content-Type": "application/form-data;charset=utf-8",
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*"
                },
                data: bodyFormData
            };

            if (this.finaldate !== "") {
                await axios(config).then(resp => {
                    this.alerts = true;
                    console.log(resp);
                });
            } else {
                this.alertmsgm = "Välj ett datum";
                this.alertm = true;
                return;
            }
        },
        deleteSchema() {
            let url = `${this.store.state.baseURL}deleteschema/${this.schedule[0].id}`;
            axios.get(url);
            this.$router.replace("/");
        },
        onRadioChange(selectedIndex) {
            this.selectedDates
                .filter((x, i) => i !== selectedIndex) // get non-selected inputs
                .forEach(x => (x.selected = false));
        },
        async update() {
            console.log(this.updatebtn.dates)
            let bodyFormData = new FormData();
            await bodyFormData.append(
                "dates",
                JSON.stringify(this.updatebtn.dates)
            );
            const config = {
                method: "post",
                url: `${this.store.state.baseURL}updateparticipant`,
                headers: {
                    "Content-Type": "application/form-data;charset=utf-8",
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*"
                },
                data: bodyFormData
            };
            await axios(config)
            this.replydone = true
        },
        
        edit(participant) {
            participant.edit = true
            this.editbtn = true
            this.updatebtn = participant
            console.log(participant)
        },
        redirect() {
            window.location.reload();
        },
    }
};
</script>

<style scopped>
.btn1 {
    height: 5px;
    width: 10px;
}
.v-radio {
    margin-bottom: 8px;
}
.social a {
    text-decoration: none;
}
.required label::after {
    content: "*";
}
.scheduletable tr {
    border-bottom: 1px solid #ccc !important;
}
.sh-table td,
.sh-table th {
    padding: 0 16px;
    height: 48px;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.table-outer::-webkit-scrollbar {
    width: 0px; /* Remove scrollbar space */
    background: transparent; /* Optional: just make scrollbar invisible */
}

.table-outer {
    overflow: scroll;
}
.name-row td {
    padding: 5px;
}

.ys-box .v-input__slot {
    align-items: center;
    justify-content: center;
}

table {
    border-collapse: collapse;
}

i.far.fa-comment-dots {
color: #959595;
    font-size: 20px;
}

.comment-label-sm {
    font-size: 10px;
    margin-bottom: 5px;
    color: #666;
    display: none;
}


@media only screen and (max-width: 600px) {
.comment-label-sm {
    display: block;
}
.comment-txt .v-label{
        display: none;
}
}


</style>
